"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

import { useGtm } from "./gtm";

export default function GtmPageViewTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousPath = useRef("");
  const gtm = useGtm();

  useEffect(() => {
    const pagePath =
      pathname + (searchParams.toString() ? `?${searchParams.toString()}` : "");

    // URL が実際に変わったときだけ発火
    if (previousPath.current !== pagePath) {
      previousPath.current = pagePath;
      gtm.sendVirtualPageView(pagePath);
    }
  }, [gtm, pathname, searchParams]);

  return null;
}
